import { queryKey } from 'constants/queryKey';
import { useQueryClient } from 'react-query';
import Logger from 'utils/logger';
import { useLocation } from 'react-router';

export const useInvalidatePostsQueries = () => {
  const queryClient = useQueryClient();
  const location = useLocation();

  return () => {
    try {
      const queries = [
        queryKey.posts(),
        queryKey.postsMeta(),
        queryKey.dashboardPosts(),
        queryKey.dashboardFailedPosts(),
        queryKey.dashboardMyTasks(),
        queryKey.dashboardTasksStatus(),
      ];

      if (location.pathname.includes('approvals/posts')) {
        queries.push(queryKey.approvalsPosts());
      }

      queries.forEach((query) => queryClient.invalidateQueries(query));
    } catch (error) {
      Logger.error(error);
    }
  };
};

export const useInvalidatePostDetailQueries = () => {
  const queryClient = useQueryClient();

  return (payload: { postId: number; commentThread?: string }) => {
    try {
      const commentThreadParams = payload.commentThread
        ? {
            postId: payload.postId,
            thread: payload.commentThread,
          }
        : undefined;

      if (commentThreadParams) {
        queryClient.invalidateQueries(
          queryKey.postCommentsThread(commentThreadParams),
        );
        queryClient.invalidateQueries(
          queryKey.postCommentsSummary(commentThreadParams),
        );
      } else {
        queryClient.invalidateQueries({
          queryKey: queryKey.postCommentsThread({
            postId: payload.postId,
            thread: 'internal',
          }),
        });
        queryClient.invalidateQueries({
          queryKey: queryKey.postCommentsThread({
            postId: payload.postId,
            thread: 'client',
          }),
        });
        queryClient.invalidateQueries({
          queryKey: queryKey.postCommentsSummary({
            postId: payload.postId,
            thread: 'internal',
          }),
        });
        queryClient.invalidateQueries({
          queryKey: queryKey.postCommentsSummary({
            postId: payload.postId,
            thread: 'client',
          }),
        });
      }

      queryClient.invalidateQueries(queryKey.postDetail(payload.postId));
      queryClient.invalidateQueries(
        queryKey.postScheduleValidation(payload.postId),
      );
    } catch (error) {
      Logger.error(error);
    }
  };
};
